import { Component, Input } from '@angular/core';

/**
 * Form field wrapper that renders a label, hint text, and inline validation error around its content.
 */
@Component({
  selector: 'es-field',
  template: `
    <div class="flex flex-col gap-1.5">
      <label class="text-xs font-medium text-[var(--text-secondary)] uppercase tracking-wider">
        {{ label }}
        @if (required) {
          <span class="text-red-500">*</span>
        }
      </label>
      <ng-content></ng-content>
      @if (hint && !error) {
        <span class="text-xs text-[var(--text-secondary)]">{{ hint }}</span>
      }
      @if (error) {
        <span class="text-xs text-red-500">{{ error }}</span>
      }
    </div>
  `,
})
export class FieldComponent {
  @Input({ required: true }) label!: string;
  @Input() required = false;
  @Input() error: string | null = null;
  @Input() hint: string | null = null;
}
